import API from 'types/api';
import { normalize } from 'normalizr';
import movieSchema from 'schemas/movie';
import episodeSchema from 'schemas/episode';
import { parseGetParams } from 'utils/routerUrl';
import { bitratesCut, supportedDrmType } from '../selectors/userAgent';
import { translate } from '../selectors/translate';

function api(store) {
  return (next) => (action) => {
    const { payload } = action;
    switch (action.type) {
      case API.GET_STREAM_VIRTUAL:
      case API.GET_STREAM: //eslint-disable-line
        const drmType = supportedDrmType(store.getState());
        action.payload = {
          ...payload,
          drm_type: drmType,
        };
        break;
      case API.GET_VIDEO_INFO_SUCCESS: {
        action.payload = normalize(payload, movieSchema);
        break;
      }
      case API.GET_EPISODES_SUCCESS:
        action.payload = normalize(payload, [episodeSchema]);
        break;
      case API.GET_VIDEO_COLLECTION_SUCCESS:
        action.payload = payload.video_list;
        break;
      case API.GET_STREAM_SUCCESS: {
        const state = store.getState();
        action.payload = bitratesCut(state)(action.payload);
        action.payload.next = payload.next && parseGetParams(payload.next).video_id;
        action.payload.prev = payload.prev && parseGetParams(payload.prev).video_id;
        break;
      }
      case API.POST_AUTH_ERROR: {
        // 403 code sent only when api performs fail2ban logic
        if (action.payload.code === 403) {
          action.payload.response.errors = [
            {
              field: 'login',
              message: translate(store.getState())('embed.fail2ban_message', {
                query: '/auth/login/any',
              }),
            },
          ];
        }
        break;
      }
      default:
        break;
    }

    return next(action);
  };
}

export default api;
